import styled, { breakpoints } from '../../../styles/theme';
import { CharacteristicsStyled } from '../CharacteristicsStyled';
import media from '../../../styles/media';
import { rem } from 'polished';

export const CharacteristicsStyledAP = styled(CharacteristicsStyled)`
    padding: 0 ${rem('8px')};

    @media (min-width: ${breakpoints.lg}px) {
        padding: 0 ${rem('64px')};
    }

    .technicalTitle {
        font-family: ${({ theme }) => theme.fonts.fontBase};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${rem(28)};
        line-height: ${({ theme }) => theme.lineHeights.h2};
        color: ${({ theme }) => theme.colors.blue6};
    }

    .technicalSubtitle {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        color: ${({ theme }) => theme.colors.blue6};
        line-height: ${({ theme }) => theme.lineHeights.h3};
        text-transform: uppercase;

        & > span {
            border-right: none;
        }
    }

    .environmentalWrapper {
        background-color: ${({ theme }) => theme.colors.grey7};
        font-size: ${({ theme }) => theme.fontSizes.textBase};

        div:first-of-type .environmentalBlock {
            border-bottom: 2px solid ${({ theme }) => theme.colors.grey4};
        }

        ${media.md`
            div:first-of-type .environmentalBlock{
                border-bottom: none;
            }
        `}
    }

    .techWrapper {
        margin-left: ${rem(15)};

        .techLabel {
            color: ${({ theme }) => theme.colors.primaryBlack};
            text-transform: none;
            font-weight: ${({ theme }) => theme.fontWeights.textBold};
            line-height: ${({ theme }) => theme.lineHeights.textSupBig};
            margin-bottom: ${rem(5)};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
        }

        span {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            color: ${({ theme }) => theme.colors.primaryBlack};
            letter-spacing: ${rem(-0.046274)};
            line-height: ${({ theme }) => theme.lineHeights.textSupMedium};
        }
    }

    .environmentalBlock {
        svg {
            path {
                stroke: ${({ theme }) => theme.colors.primaryBlack};
            }
        }

        .environmentalLabel {
            text-transform: none;
            line-height: ${({ theme }) => theme.lineHeights.textSupBig};
            color: ${({ theme }) => theme.colors.primaryBlack};
        }
        span {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            letter-spacing: ${rem(-0.046274)};
            line-height: ${({ theme }) => theme.lineHeights.textSupMedium};
            color: ${({ theme }) => theme.colors.primaryBlack};
        }
    }

    .featureList {
        color: ${({ theme }) => theme.colors.grey12};
    }

    .technicalWrapper {
        border-top: 1px solid ${({ theme }) => theme.colors.grey9};
        color: ${({ theme }) => theme.colors.grey12};
    }

    .technicalDetails {
        color: ${({ theme }) => theme.colors.blue6};
        font-size: ${({ theme }) => theme.fontSizes.textMedium};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        margin-bottom: 0 !important;
    }

    .featureTitleWrapper {
        background-color: #f1f3f2;

        ${media.xs`
            background-color: transparent;
        `}
    }

    .featureTitleWide {
        color: ${({ theme }) => theme.colors.grey12};
        border-top: none;
    }

    .featureItemList {
        color: ${({ theme }) => theme.colors.grey12};
    }

    .icon-wrapper {
        svg {
            width: ${rem(16)};
            height: ${rem(16)};
        }
    }

    .Collapsible {
        .Collapsible__trigger {
            padding: 0;

            .featureTitleWide {
                padding: 0;
                margin: 0;
                font-size: ${({ theme }) => theme.fontSizes.textBase};
                color: ${({ theme }) => theme.colors.blue6};
            }
        }

        .technicalFeaturesModule {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            text-align: left;

            .featureList {
                color: ${({ theme }) => theme.colors.blue6};
                line-height: ${({ theme }) => theme.lineHeights.textMedium};
            }

            .featureItemList {
                color: ${({ theme }) => theme.colors.blue6};
                font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                font-size: ${({ theme }) => theme.fontSizes.textBase};
            }
        }

        .legalText {
            font-size: ${({ theme }) => theme.fontSizes.textTiny};
            color: ${({ theme }) => theme.colors.grey12};

            span {
                line-height: ${({ theme }) => theme.lineHeights.textSmall};
            }

            a {
                color: ${({ theme }) => theme.colors.primary};

                &:hover {
                    color: ${({ theme }) => theme.colors.primaryBlack};
                }
            }
        }
    }

    .technicalDetails {
        font-size: ${({ theme }) => theme.fontSizes.h5};
        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        margin-bottom: ${rem(40)};
    }

    .technicalWrapper {
        border: none;

        .featureTitle {
            font-size: ${({ theme }) => theme.fontSizes.textBase};
            color: ${({ theme }) => theme.colors.blue6};
        }
    }

    .featureList {
        margin-top: 0;
        margin-bottom: ${rem(20)};
        padding-bottom: 0;

        li {
            list-style: disc outside none;
            display: list-item;
            margin-left: ${rem(15)};

            &::before {
                content: normal;
            }
        }

        .featureValue {
            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
        }
    }

    .featureListWithValue {
        li {
            display: flex;
            margin-left: 0;
        }

        margin: 0;
        padding: 0;
    }

    .specificationBlock {
        margin: 0;
        border-bottom: solid ${({ theme }) => theme.colors.grey7};
        padding-top: ${rem(40)};

        &:last-child {
            border-bottom: 1px solid red;
        }
    }

    .hideTechnicalDetail {
        a {
            color: ${({ theme }) => theme.colors.primary};
            font-size: ${({ theme }) => theme.fontSizes.textSupBase};

            &:hover {
                color: ${({ theme }) => theme.colors.primaryBlack};
            }
        }
    }
`;
